module.exports = __webpack_public_path__ + "img/icon_vod_like_w_on.e512127f.svg";